import { render, staticRenderFns } from "./TicketQuery.vue?vue&type=template&id=757d47bd&scoped=true&"
import script from "./TicketQuery.vue?vue&type=script&lang=js&"
export * from "./TicketQuery.vue?vue&type=script&lang=js&"
import style0 from "./TicketQuery.vue?vue&type=style&index=0&id=757d47bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757d47bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow})
